export function Hero() {
  return (
    <section className="text-center">
      <h1 className="text-4xl sm:text-5xl font-cursive mb-6 sm:mb-8 text-primary-700">
        Wayland Rod &amp; Gun Club
      </h1>
    </section>
  );
}